<template>
    <div>
        <NavPage></NavPage>
        <!-- <div class="slide">
            <img src="@/assets/img/0302y12000cp1fr3rB841.jpg" alt="">
        </div> -->
        <div class="content">
          <SlideShow></SlideShow>
        </div>
        <div class="contact">
            <h2>联系我们</h2>
            <p>公司网址: www.cddmetc.com</p>
            <div style="display:flex">
                <p>联系电话：</p>
                <p>
                    18980611239 <br>
                    028-86656636
                </p>
            </div>
            <div style="display:flex">
                <p>邮 箱：</p>
                <p>
                    25048129@qq.com 
                </p>
            </div>
            <p>公司地址： 成都市成华区奥园国际中心24层10号</p>
        </div>
        <FooterPage></FooterPage>
    </div>
</template>

<script>
import NavPage from '@/components/NavPage.vue'
import SlideShow from '@/components/SlideShow.vue'
import FooterPage from '@/components/FooterPage.vue'
export default {
    name: 'ContactUs',
    components: {
        NavPage,
        SlideShow,
        FooterPage
    },
}
</script>

<style scoped>
.content {
  width: 1340px;
  margin: auto;
}
.slide img {
    width: 100%;
    height: 500px;
}
.contact {
    width: 60%;
    margin: auto;
    /* background-color: aquamarine; */
    text-align: left;
    line-height: 50px;
    font-size: 18px;
    font-weight: 500;
}
.contact h2 {
    text-align: center;
}
p {
    margin: 0;
}
</style>